<template>
  <div class="box">
    <div class="box__content">
      <div class="box__header">
        <img class="subtitle__icon" src="@/assets/icons/ico_home-accent.svg" alt="">
        <h2 class="box__title">{{ $t(`${namespace}.companyInfo`) }}</h2>
        <v-spacer />

        <router-link
          v-if="isAdminProfile || hasRole('company', 'ROLE_PUT_COMPANY_ID_PHONE')"
          class="box__header__edit"
          :to="{
            name: 'EditCompany',
            params: { id: data.id }
          }"
        >
          {{ $t('Common.edit') }} <v-icon color="accent">edit</v-icon>
        </router-link>
      </div>

      <div class="box__body">
        <div class="mb-3">
          <div class="caption gray-6--text">CNPJ</div>
          <div v-if="data.documentId">{{ data.documentId | cnpj }}</div>
          <div v-else>{{ $t('Common.uninformed') }}</div>
        </div>

        <div class="mb-3">
          <div class="caption gray-6--text">{{ $t('Common.phone') }}</div>
          <div v-if="data.phone">{{ data.phone | phoneWithDDI }}</div>
          <div v-else>{{ $t('Common.uninformed') }}</div>
        </div>

        <div class="mb-3">
          <div class="caption gray-6--text">CEP</div>
          <div v-if="data.postalCode">{{ data.postalCode | cep }}</div>
          <div v-else>{{ $t('Common.uninformed') }}</div>
        </div>

        <v-layout row wrap>
          <v-flex sm6 xs12>
            <div class="mb-3 mr-3">
              <div class="caption gray-6--text">{{ $t('Common.address') }}</div>
              <div v-if="data.address">{{ data.address }}</div>
              <div v-else>{{ $t('Common.uninformed') }}</div>
            </div>
          </v-flex>

          <v-flex sm6 xs12>
            <div class="mb-3">
              <div class="caption gray-6--text">{{ $t('Common.district') }}</div>
              <div v-if="data.district">{{ data.district }}</div>
              <div v-else>{{ $t('Common.uninformed') }}</div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex sm6 xs12>
            <div class="mb-3 mr-3">
              <div class="caption gray-6--text">{{ $t('Common.city') }}</div>
              <div v-if="data.city">{{ data.city }}</div>
              <div v-else>{{ $t('Common.uninformed') }}</div>
            </div>
          </v-flex>

          <v-flex sm6 xs12>
            <div class="mb-3">
              <div class="caption gray-6--text">{{ $t('Common.state') }}</div>
              <div v-if="data.state">{{ data.state }}</div>
              <div v-else>{{ $t('Common.uninformed') }}</div>
            </div>
          </v-flex>
        </v-layout>

        <div>
          <div class="caption gray-6--text">{{ $t(`${namespace}.emailList`) }}</div>
          <div v-if="isValidArray(contactEmailList)">
            <span
              v-for="(email, index) in contactEmailList"
              :key="email"
            >
              <span v-if="contactEmailList.length > 1 && index === contactEmailList.length - 1"> {{ $t('Common.and') }} </span>
              <a
                :href="`mailto:${email}`"
                title=""
                class="text--link accent--text"
              >{{ email }}</a>
              <span v-if="index < contactEmailList.length - 2">, </span>
            </span>
          </div>
          <div v-else>{{ $t('Common.uninformed') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isArray, hasRole } from 'utils/functions'

export default {
  name: 'CompanyBasicInfo',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      isAdminProfile: state => {
        return state.session.user.business.isAdministrator ||
          state.userClaims.claims.profiles['ROLE_ADMINISTRATOR'] ||
          state.userClaims.claims.profiles['ROLE_FINANCIAL_ADMIN']
      }
    }),

    contactEmailList () {
      if (this.data.contactEmailList) {
        return this.data.contactEmailList.split(',')
      }

      return []
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyDetailsPage'
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
.company-status {
  margin: 24px 0 0;

  @media (min-width: 992px) {
    margin: 0;
    position: absolute;
    right: 16px;
    top: 18px;
  }
}
</style>
